<table
  class="comp table-striped borderless"
  width="100%"
  cellspacing="0"
  border="0"
  (mouseleave)="rowHovered(null)"
>
  <tbody>
    <tr
      *ngFor="let student of students; let i = index"
      [ngClass]="{
        hoveredRow: bodyRowHoveredIndex == i || fixedColRowHoveredIndex == i
      }"
      (mouseover)="rowHovered(i)"
    >
      <td class="name-col comp">
        <div class="checkbox-and-name">
          <mat-checkbox
            [checked]="student.selected"
            (change)="studentSelected.emit(student.studentKEY)"
            class="helper-checkbox"
          ></mat-checkbox>
          <div>
            <a
              [routerLink]="'/profile/student/' + student['studentKEY']"
              (click)="setTitle('Student Profile')"
              class="student-name"
            >
              {{
                getFormattedStudentName(
                  student["firstName"],
                  student["lastName"]
                )
              }}
            </a>
            <div
              *ngIf="schoolsForTable && schools && schools.length > 1"
              class="school-label"
            >
              {{ schoolsForTable[student["school_id"]]?.officialSchoolName }}
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
